import { datetimeFormatter } from 'utils/datetime';
import property from 'lodash/property';
import identity from 'lodash/identity';
import sortByFp from 'lodash/fp/sortBy';
import filterFp from 'lodash/fp/filter';
import mapFp from 'lodash/fp/map';
import flow from 'lodash/flow';

const getCountryName = property(['country', 'name']);
const formatUserCountries = flow(
  mapFp(getCountryName),
  filterFp(identity),
  sortByFp(identity)
);

export const usersTableColumns = [
  { field: 'role_in_string', label: 'Role' },
  { field: 'display_name', label: 'User Name' },
  { field: 'email', label: 'Email' },
  { field: 'phone', label: 'Phone (WhatsApp)' },
  { field: 'country_list', label: 'Country' },
  // {
  //   field: 'user_countries',
  //   label: 'Country',
  //   formatter: (value) => {
  //     let country = '';
  //     if (value && value.length > 0) {
  //       country = formatUserCountries(value).join(', ');
  //     }
  //     return country;
  //   },
  // },
  { field: 'lastmoddate', label: 'Last updated', formatter: datetimeFormatter },
];
